var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[_c('template',{slot:"page-content"},[_vm._t("page-content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }